<template>
    <Teleport to="body">
        <div v-if="internalOpen" class="dialog-overlay" @click.self="closeDialog">
            <v-card :width="width" class="dialog-card" :ripple="false" @click.stop>
                <v-card-title style="display: flex; align-items: center;">
                    <h2 style="font-weight: bold; flex: 1;">{{ title }}</h2>
                    <v-icon @click="closeDialog" color="accent" style="cursor: pointer;">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="text--text">
                    <v-container>
                        <slot></slot>
                    </v-container>
                </v-card-text>
                <v-card-actions class="dialog-actions">
                    <v-btn
                        variant="outlined"
                        @click="closeDialog"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        :color="confirmDelete ? 'error' : 'primary'"
                        @click="handleDelete"
                        :loading="loading"
                        :disabled="disableConfirm"
                        variant="flat"
                    >
                        {{ buttonTitle }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </div>
    </Teleport>
</template>

<script>
export default {
    name: "AppConfirmDialog",
    emits: ['close', 'confirm'],
    props: {
        open: {
            required: true,
            type: Boolean
        },
        title: {
            required: true,
            type: String
        },
        width: {
            required: false,
            type: Number,
            default: 500
        },
        submitButtonTitle: {
            type: String,
        },
        loading: {
            type: Boolean
        },
        confirmDelete: {
            type: Boolean,
            default: false
        },
        disableConfirm: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            internalOpen: false
        }
    },
    watch: {
        open: {
            immediate: true,
            handler(newValue) {
                this.internalOpen = newValue
            }
        },
        internalOpen(newValue) {
            if (!newValue && this.open) {
                this.$emit('close')
            }
        }
    },
    methods: {
        handleDelete() {
            this.$emit('confirm');
        },
        closeDialog() {
            this.internalOpen = false
            this.$emit('close')
        }
    },
    computed: {
        buttonTitle() {
            if (this.submitButtonTitle) return this.submitButtonTitle
            if (this.confirmDelete) return 'Delete'
            else return 'Confirm'
        }
    }
}
</script>

<style scoped>
.dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: 8vh;
    z-index: 2000;
}

.dialog-card {
    border-top: 4px solid #33D3FF;
    border-radius: 16px !important;
    max-height: 84vh;
    overflow-y: auto;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.dialog-actions {
    padding: 20px !important;
    display: flex !important;
    justify-content: center !important;
    gap: 12px;
    width: 100% !important;
    border-top: 1px solid #E5E7EB;
}
</style>